import { Layout } from 'antd';
import clsx from 'clsx';
import React, { ReactNode } from 'react';
import styles from './AnalyticsLayout.module.scss';

export interface AnalyticsLayoutProps {
  globalContent?: ReactNode;
  navigationContent?: ReactNode;
  children: ReactNode;
  removeTopSectionBorder?: boolean;
}

const AnalyticsLayout: React.FC<AnalyticsLayoutProps> = ({
  globalContent,
  navigationContent,
  children,
  removeTopSectionBorder = false,
}) => {
  return (
    <Layout className={`${styles.analyticsLayout}`}>
      <div className={styles.analyticsWrapper}>
        <div
          className={clsx(
            styles.topSection,
            !removeTopSectionBorder && styles.topSectionBorder
          )}
        >
          <div className={styles.globalSectionContent}>{globalContent}</div>
        </div>

        <div className={styles.bottomSection}>
          <div className={styles.navigationSectionContent}>
            {navigationContent}
          </div>
        </div>
      </div>

      <div
        style={{
          zIndex: 1,
          width: '100%',
        }}
      >
        {children}
      </div>
    </Layout>
  );
};

export default AnalyticsLayout;
